import { z } from 'zod';

export const UserDetailsValidator = z.object({
  given_name: z.string().min(1, {
    message: 'Please enter first name.',
  }),
  family_name: z.string().min(1, {
    message: 'Please enter last name.',
  }),
  birthdate: z.date(),
  gender: z.string().min(1, {
    message: 'Please enter gender.',
  }),
  height: z.string().min(1, {
    message: 'Please enter height.',
  }),
  weight: z.string().min(1, {
    message: 'Please enter weight.',
  }),
  height_unit: z.string().min(1, {
    message: 'Please select height unit.',
  }),
  weight_unit: z.string().min(1, {
    message: 'Please enter weight unit.',
  }),
});

export type UserDetailsFormData = z.infer<typeof UserDetailsValidator>;
